export default "__VITE_ASSET__1DuHWt7r__"